module.exports = __webpack_public_path__ + "static/media/photo2.fe2ce265.jpg";